import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {MainLayout} from '~/layouts/main';
export const meta = {
  title: 'LSP | Ограничения и подводные камни',
  description: 'Ограничения принципа подстановки Барбары Лисков, с которыми разработчики сталкиваются чаще всего'
};
const MDXLayout = ({children}) => _jsx(MainLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    h2: "h2",
    li: "li",
    p: "p",
    section: "section",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_components.section, {
    children: [_jsx(_components.h1, {
      children: "Ограничения и подводные камни"
    }), _jsx(_components.p, {
      children: "Всем принципам приходится сталкиваться с реальностью, которая накладывает ограничения на их применение. Для LSP наиболее характерны дороговизна изменения модели иерархии, многословность контрактов, предел выделения суперкласса."
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Изменение иерархии дорого"
      }), _jsx(_components.p, {
        children: "LSP помогает проектировать отношения между сущностями, учитывая возможные изменения в требованиях. Но вероятность спроектировать систему хорошо с первого раза — низкая."
      }), _jsx(_components.p, {
        children: "Стремление следовать LSP может привести к изменению иерархии объектов в системе. Большие изменения в структурах — дороги, как по времени, так и по деньгам."
      }), _jsx(_components.p, {
        children: "Также изменение структуры затрагивает большое количество компонентов. Если код плохо покрыт тестами, переписывание может привести к неработающему приложению."
      })]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Использование контрактов ресурсозатратно"
      }), _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "/lsp/patterns",
          children: "Использование контрактов"
        }), " позволяет избежать усиления предусловий и ослабления постусловий. Однако, контракт увеличивает сложность проекта, а также увеличивает сроки разработки."]
      }), _jsx(_components.p, {
        children: "Покрытие методов контрактными спецификациями затратно по времени; контракты зачастую многословны и дублируют тесты. В некоторых случаях контракты снижают производительность кода."
      })]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Выделение суперкласса имеет предел"
      }), _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "/lsp/patterns",
          children: "Выделение суперкласса"
        }), " позволяет избежать дублирования, но имеет предел вложенности. Невозможно выносить функциональность всё выше и выше без последствий — чрезмерное вынесение функциональности наверх может привести к появлению ", _jsx(_components.a, {
          href: "https://ru.wikipedia.org/wiki/%D0%91%D0%BE%D0%B6%D0%B5%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D1%8B%D0%B9_%D0%BE%D0%B1%D1%8A%D0%B5%D0%BA%D1%82",
          children: "божественного объекта"
        }), "."]
      }), _jsx(_components.p, {
        children: "Также выделение суперкласса не гарантирует правильную иерархию объектов — может случиться, что новые бизнес-требования добавят сущность, которая не будет вписываться в уже изменённую иерархию."
      })]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Материалы к разделу"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://dzone.com/articles/solid-liskov-substitution-principle#28",
            children: "How to Correctly Model Inheritance"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/%D0%9A%D0%BE%D0%BD%D1%82%D1%80%D0%B0%D0%BA%D1%82%D0%BD%D0%BE%D0%B5_%D0%BF%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5",
            children: "Контрактное программирование"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://refactoring.guru/ru/extract-superclass",
            children: "Извлечение суперкласса"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/%D0%91%D0%BE%D0%B6%D0%B5%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D1%8B%D0%B9_%D0%BE%D0%B1%D1%8A%D0%B5%D0%BA%D1%82",
            children: "Божественный объект"
          })
        }), "\n"]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  return _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  });
}
